var map = {
	"./accessibility.svg": 2016,
	"./account.svg": 1236,
	"./audiodeskription.svg": 4175,
	"./audiodeskription_aus.svg": 3607,
	"./auftrag.svg": 3637,
	"./autoplay.svg": 2448,
	"./breakingnews.svg": 1591,
	"./bubble_heart.svg": 9588,
	"./cast_devices.svg": 7524,
	"./clock.svg": 3156,
	"./datenschutz.svg": 1925,
	"./fast_backward.svg": 8790,
	"./gebaerdensprache.svg": 6179,
	"./group.svg": 5966,
	"./headphones.svg": 6208,
	"./info.svg": 1403,
	"./language.svg": 9740,
	"./local.svg": 1282,
	"./lock.svg": 8709,
	"./movie.svg": 5075,
	"./navigation.svg": 5367,
	"./password_show.svg": 1423,
	"./phone.svg": 6914,
	"./play.svg": 7637,
	"./podcast.svg": 9940,
	"./questionmark.svg": 5616,
	"./radio.svg": 5558,
	"./rating.svg": 9897,
	"./replay.svg": 433,
	"./settings.svg": 6461,
	"./share.svg": 1409,
	"./speechbubble.svg": 4741,
	"./speed.svg": 4008,
	"./sport.svg": 7189,
	"./technische_probleme.svg": 5941,
	"./ticket.svg": 9586,
	"./tv.svg": 7381,
	"./untertitel.svg": 3073,
	"./untertitel_aus.svg": 6334,
	"./video.svg": 248,
	"./volume_sound.svg": 9311,
	"./web.svg": 8257,
	"./werbung_finanzierung.svg": 3676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6142;